/**
 * BBS 게시판 타입 코드 및 경로 매핑
 */
export const BBS_TP_CODES = {
  // 기술 수요
  DEMAND_TECH_DEMAND_LIST: 'DEMAND_TECH_DEMAND_LIST', // 기술 수요
  DEMAND_EXPERT_SEARCH: 'DEMAND_EXPERT_SEARCH', // 전문가/기관 탐색
  DEMAND_TECH_DEMAND_CASES: 'DEMAND_TECH_DEMAND_CASES', // 기술 수요 진행 사례

  // GLOW 소식
  GLOW_NEWS_NOTICE: 'GLOW_NEWS_NOTICE', // 공지사항
  GLOW_NEWS_NEWS: 'GLOW_NEWS_NEWS', // GLOW NEWS

  // GLOW 성과
  GLOW_PERFORMANCE_MATCHING: 'GLOW_PERFORMANCE_MATCHING', // 매칭·협업
  GLOW_PERFORMANCE_CASE: 'GLOW_PERFORMANCE_CASE', // 사례 소개
  GLOW_PERFORMANCE_PORTFOLIO: 'GLOW_PERFORMANCE_PORTFOLIO', // 성과·포트폴리오

  // 지원 센터
  SUPPORT_CENTER_LIBRARY: 'SUPPORT_CENTER_LIBRARY', // 자료실
  SUPPORT_CENTER_MANUAL: 'SUPPORT_CENTER_MANUAL', // 이용 메뉴얼
  SUPPORT_CENTER_FAQ: 'SUPPORT_CENTER_FAQ', // faq
  SUPPORT_CENTER_INQUIRY: 'SUPPORT_CENTER_INQUIRY', // 문의하기
};

/**
 * 경로 키워드 기반 BBS 타입 코드 판별 매핑
 * - URL에 포함된 고유 키워드를 기준으로 게시판 코드를 매핑합니다.
 */
export const PATH_BBS_TP_MAP = {

  // 기술 수요
  'tech-demand-list': BBS_TP_CODES.DEMAND_TECH_DEMAND_LIST,
  /** 통합 전문가 탐색(기술수요 포털) — /experts/demand */
  'experts/demand': BBS_TP_CODES.DEMAND_EXPERT_SEARCH,
  'expert-search': BBS_TP_CODES.DEMAND_EXPERT_SEARCH,
  'tech-demand-cases': BBS_TP_CODES.DEMAND_TECH_DEMAND_CASES,

  // GLOW 소식 : glow-news
  'notice': BBS_TP_CODES.GLOW_NEWS_NOTICE,
  'news': BBS_TP_CODES.GLOW_NEWS_NEWS,

  // GLOW 성과 : glow-performance
  'matching': BBS_TP_CODES.GLOW_PERFORMANCE_MATCHING,
  'case': BBS_TP_CODES.GLOW_PERFORMANCE_CASE,
  'portfolio': BBS_TP_CODES.GLOW_PERFORMANCE_PORTFOLIO,

  // 지원 센터 : support-center
  'library': BBS_TP_CODES.SUPPORT_CENTER_LIBRARY,
  'manual': BBS_TP_CODES.SUPPORT_CENTER_MANUAL,
  'faq': BBS_TP_CODES.SUPPORT_CENTER_FAQ,
  'inquiry': BBS_TP_CODES.SUPPORT_CENTER_INQUIRY,
};
